module.exports = __webpack_public_path__ + "309d33cb38aff1eb0744fb39dbfbc5ef.jpg";